import React from "react";
import { useForm } from "react-hook-form";
import emailjs from "emailjs-com";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data, e) => {
    emailjs
      .send(
        "service_enf8wll",
        "template_5o098u1",
        data,
        "2eB9Q6psF2gmI05X7"
      )
      .then((response) => {
        console.log("Message envoyé avec succès!", response.status, response.text);
        e.target.reset();
        toast.success("message envoyé avec succès !");
      })

      .catch((error) => {
        console.error("Une erreur s'est produite lors de l'envoi du message:", error);
        toast.error("Une erreur s'est produite lors de l'envoi du message.");
      });
  };

  return (
    <>
      <form className="contactform" onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-12 col-md-6">
            <div className="form-group">
              <input
                {...register("name", { required: true })}
                type="text"
                name="name"
                placeholder="NOM COMPLET"
              />
              {errors.name && errors.name.type === "required" && (
                <span className="invalid-feedback">Veuillez inserer votre nom</span>
              )}
            </div>
          </div>
          {/* End .col */}

          <div className="col-12 col-md-6">
            <div className="form-group">
              <input
                {...register(
                  "email",
                  {
                    required: "Veuillez inserer votre adresse e-mail",
                    pattern: {
                      value: /\S+@\S+\.\S+/,
                      message: "La valeur saisie ne correspond pas au format de l'e-mail",
                    },
                  },
                  { required: true }
                )}
                type="email"
                name="email"
                placeholder="ADRESSE E-MAIL"
              />
              {errors.email && (
                <span className="invalid-feedback">{errors.email.message}</span>
              )}
            </div>
          </div>
          {/* End .col */}
          <div className="col-12 col-md-12">
            <div className="form-group">
              <input
                {...register("subject", { required: true })}
                type="text"
                name="subject"
                placeholder="OBJET"
              />
              {errors.subject && (
                <span className="invalid-feedback">Veuillez inserer l'objet</span>
              )}
            </div>
          </div>
          {/* End .col */}

          <div className="col-12">
            <div className="form-group">
              <textarea
                {...register("message", { required: true })}
                name="message"
                placeholder="VOTRE MESSAGE"
              ></textarea>
              {errors.message && (
                <span className="invalid-feedback">Veuillez inserer votre message</span>
              )}
            </div>
          </div>
          {/* End .col */}

          <div className="col-12">
            <button type="submit" className="button">
              <span className="button-text">envoyer</span>
              <span className="button-icon fa fa-send"></span>
            </button>
          </div>
          {/* End .col */}
        </div>
      </form>

      {/* End contact */}
      <ToastContainer />
    </>
  );
};

export default Contact;
